// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"d668bba6","164":"572f8339","282":"8e47122d","561":"75483f83","574":"6321837d","604":"d0e71f3f","727":"23bdd121","992":"f7954bfd"}[chunkId] + ".chunk.js";
};